import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { QuestionFilled, QuestionOutlined } from '@zeelool/icon';
import { useContext } from 'react';
import { EPlatform } from '../../utils/enums/platform-enum';

// 根据设备类型返回不同的图标
export default function QuestionResponsive({ className = 'f16', ...props }: any) {
  const { deviceType } = useContext(ResponsiveContext);
  return deviceType === EPlatform.WEB ? (
    <QuestionFilled className={`${className} f16 text-[#a3a3a3] cursor-pointer`} {...props} />
  ) : (
    <QuestionOutlined className={`${className} f16`} {...props} />
  );
}
